import userComponents from './user'
import cardComponents from './cards'
import shopComponents from './shop'

export default {
  ...userComponents,
  ...cardComponents,
  ...shopComponents,
}
